import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { DisableAction, EnableAction, FormControlState } from 'ngrx-forms';
import * as fromRoot from '../../../reducers/';

@Directive({
  selector: '[mdDisableControl]',
})
export class DisableControlDirective implements OnChanges {
  // @ts-expect-error
  @Input() mdDisableInput: boolean;
  // @ts-expect-error
  @Input() ngrxFormControlState: FormControlState<any>;

  constructor(private store: Store<fromRoot.State>) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.mdDisableInput) {
      setTimeout(() =>
        this.store.dispatch(
          changes.mdDisableInput.currentValue
            ? new DisableAction(this.ngrxFormControlState.id)
            : new EnableAction(this.ngrxFormControlState.id),
        ),
      );
    }
  }
}
